import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';
import { SsoRedirect } from '../authState';


const KEY_ACTION = ActionType.LoginRequest;
const ACTIONS = [
  ActionType.YmcaLoginRequest,
  ActionType.YmcaLoginResponse,
  ActionType.YmcaLoginError,
];

export const INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS';

type ErrorPayload = { code?: string };
type Payload = SsoRedirect & ErrorPayload;


type Meta = {
  email: string;
};


/**
 * Dispatch this action to authenticate to the portal through Ymca SSO
 * @param projectId - project display id
 * @param returnUrl - alternate way to get project display id. 
 */
export const ymcaLoginAction = (projectId?: string, returnUrl?: string) => makeApiAction<Payload, Meta>({
  method: 'POST',
  endpoint: Endpoints.YmcaLogin,
  headers: { 'content-type': 'application/json' },
  body: JSON.stringify({ projectId: projectId, returnUrl: returnUrl }),
  types: makeRsaaTypes<Payload, Meta>(ACTIONS),
  bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    const code = payload?.code;
    return addError(state, KEY_ACTION, errorMsg, undefined, code ? { code } : undefined);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'ssoRedirect'], payload, successState);
};

export const ymcaLoginReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);